module.exports = __webpack_public_path__ + "static/media/second-img.4652ce97.jpg";